if (!customElements.get('dce-hat-creator')) {
  customElements.define('dce-hat-creator', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      this.form = document.getElementById(this.dataset.productForm);
      this.patchWrap = this.querySelector('[data-patch-wrap]');
      this.patch = this.querySelector('[data-patch]');
      this.stage = this.querySelector('[data-stage]');
      this.hatImage = this.querySelector('[data-hat-image]');
      this.artImage = this.querySelector('[data-art-preview]');
      this.previewText = this.querySelector('[data-preview-text]');
      this.previewData = this.querySelector('[data-preview-data]');
      this.artName = this.querySelector('[data-art-name]');
      this.approvedPreviewInput = this.querySelector('[data-approved-preview]');
      this.productionArtInput = this.querySelector('[data-production-art]');
      this.exportStatus = this.querySelector('[data-export-status]');
      this.patchSize = this.querySelector('[data-patch-size]');
      this.logoSize = this.querySelector('[data-logo-size]');
      this.diecutSpacing = this.querySelector('[data-diecut-spacing]');
      this.logoX = this.querySelector('[data-logo-x]');
      this.logoY = this.querySelector('[data-logo-y]');
      this.state = { model: '', modelName: '', colorName: '', front: '', side: '', view: 'front', x: 50, y: 43, scale: 100, logoSize: 75, logoX: 0, logoY: 0, logoRotation: 0, diecutSpacing: 8, border: 'With border', shapeSize: '3 × 2 in', placement: 'Center front', artSource: '', diecutMask: '', diecutAspect: 1, patchTouched: false, dragging: false };
      this.bind();
      const defaultLeather = this.checked('[data-leather]') || this.q('[data-leather]');
      if (defaultLeather) {
        defaultLeather.checked = true;
        this.selectLeather(defaultLeather);
      }
      this.state.patchTouched = false;
      this.updatePatch();
      this.updateSummary();
      this.updateProgress();
    }

    q(selector) { return this.querySelector(selector); }
    qa(selector) { return [...this.querySelectorAll(selector)]; }
    checked(selector) { return this.querySelector(`${selector}:checked`); }

    bind() {
      // Color cards also carry a data-model attribute for filtering, so bind
      // the model-selection handler only to the actual hat-series inputs.
      this.qa('[data-model][data-key]').forEach(input => input.addEventListener('change', () => this.selectModel(input)));
      this.qa('[data-color]').forEach(input => input.addEventListener('change', () => this.selectColor(input)));
      this.qa('[data-leather]').forEach(input => input.addEventListener('change', () => { this.state.patchTouched = true; this.selectLeather(input); }));
      this.qa('[data-shape]').forEach(input => input.addEventListener('change', () => { this.state.patchTouched = true; this.selectShape(input); }));
      this.qa('[data-placement]').forEach(input => input.addEventListener('change', () => this.selectPlacement(input)));
      this.qa('.dce-choice--placement').forEach(label => label.addEventListener('click', event => {
        event.preventDefault();
        const input = label.querySelector('[data-placement]');
        if (input) this.selectPlacement(input);
      }));
      this.qa('[data-view]').forEach(button => button.addEventListener('click', () => this.setView(button.dataset.view)));
      this.qa('[data-resize]').forEach(button => button.addEventListener('click', () => { this.state.scale = Math.max(60, Math.min(140, this.state.scale + Number(button.dataset.resize))); this.updatePatch(); }));
      this.patchSize.addEventListener('input', event => { this.state.scale = Number(event.target.value); this.updatePatch(); });
      this.logoSize.addEventListener('input', event => { this.state.logoSize = Number(event.target.value); this.updatePatch(); });
      this.logoX.addEventListener('input', event => { this.state.logoX = Number(event.target.value); this.updatePatch(); });
      this.logoY.addEventListener('input', event => { this.state.logoY = Number(event.target.value); this.updatePatch(); });
      this.q('[data-rotate-logo]').addEventListener('click', () => {
        this.state.logoRotation = (this.state.logoRotation + 90) % 360;
        if (this.state.artSource && this.patchWrap.dataset.shape === 'diecut') this.renderArtwork();
        this.updatePatch();
      });
      this.diecutSpacing.addEventListener('input', event => {
        this.state.diecutSpacing = Number(event.target.value);
        this.q('[data-diecut-spacing-value]').textContent = `${this.state.diecutSpacing} px`;
        this.state.patchTouched = true;
        if (this.diecutSource) this.createDiecutMask(this.diecutSource);
        this.updatePatch();
        this.updateProgress();
      });
      this.qa('[data-border]').forEach(input => input.addEventListener('change', () => { this.state.patchTouched = true; this.state.border = input.value; this.updatePatch(); this.updateProgress(); }));
      this.q('[data-color-search]').addEventListener('input', () => this.filterColors());
      this.q('[data-art]').addEventListener('change', event => this.previewArtwork(event.target.files?.[0]));
      this.q('[data-custom-text]').addEventListener('input', event => { this.previewText.textContent = event.target.value.trim() || 'YOUR LOGO'; if (!this.state.artSource) this.previewText.hidden = false; this.updateProgress(); });
      this.q('[data-approval]').addEventListener('change', () => this.updateProgress());
      this.q('[data-reset]').addEventListener('click', () => this.reset());
      this.patchWrap.addEventListener('dragstart', event => event.preventDefault());
      this.patchWrap.addEventListener('pointerdown', event => { event.preventDefault(); this.state.dragging = true; this.patchWrap.setPointerCapture(event.pointerId); });
      this.patchWrap.addEventListener('pointermove', event => this.dragPatch(event));
      this.patchWrap.addEventListener('pointerup', () => { this.state.dragging = false; });
      this.patchWrap.addEventListener('pointercancel', () => { this.state.dragging = false; });
      if (this.form) this.form.addEventListener('submit', event => this.handleSubmit(event), true);
    }

    selectModel(input) {
      this.state.model = input.dataset.key;
      this.state.modelName = input.value;
      this.state.colorName = '';
      this.qa('[data-color]').forEach(color => { color.checked = false; });
      const fitted = ['flexfit-6533', 'flexfit-6597'].includes(this.state.model);
      const sizes = this.q('[data-sizes]');
      sizes.hidden = !fitted;
      this.qa('[data-size]').forEach(size => { size.disabled = !fitted; size.required = fitted; if (!fitted) size.checked = false; });
      this.q('[data-color-help]').textContent = `Showing colors for ${input.value}`;
      this.q('[data-view-switch]').hidden = true;
      this.filterColors();
      this.updateSummary();
      this.updateProgress();
    }

    filterColors() {
      const term = this.q('[data-color-search]').value.trim().toLowerCase();
      this.qa('[data-color-card]').forEach(card => {
        const belongs = card.dataset.model === this.state.model || card.dataset.model === 'all';
        card.hidden = !(this.state.model && belongs && card.dataset.search.includes(term));
        const model = card.querySelector('[data-model-name]');
        if (model) model.textContent = this.state.modelName;
      });
    }

    selectColor(input) {
      this.state.colorName = input.value;
      if (input.dataset.front) {
        this.state.front = input.dataset.front;
        this.state.side = input.dataset.side || '';
        this.q('[data-view-switch]').hidden = false;
        this.setView('front');
      }
      this.updateSummary();
      this.updateProgress();
    }

    setView(view) {
      const side = view === 'side' && this.state.side;
      this.state.view = side ? 'side' : 'front';
      if (this.state.front) this.hatImage.src = side ? this.state.side : this.state.front;
      this.patchWrap.hidden = Boolean(side);
      this.q('[data-view-label]').textContent = side ? 'SIDE VIEW · PATCH HIDDEN' : 'FRONT · DESIGN VIEW';
      this.qa('[data-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.view === this.state.view)));
    }

    selectLeather(input) {
      this.patch.style.backgroundColor = input.dataset.bg;
      this.patch.style.color = input.dataset.ink;
      this.patchWrap.style.color = input.dataset.ink;
      this.patch.style.backgroundImage = `url("${input.dataset.texture}")`;
      this.patch.style.backgroundSize = 'cover';
      this.patch.style.backgroundPosition = 'center';
      this.patch.dataset.pattern = 'manufacturer';
      this.renderArtwork();
      this.updateSummary();
      this.updateProgress();
    }

    selectShape(input) {
      this.patchWrap.dataset.shape = input.dataset.shapeKey;
      this.patch.dataset.shape = input.dataset.shapeKey;
      this.q('[data-diecut-spacing-control]').hidden = input.dataset.shapeKey !== 'diecut';
      this.state.shapeSize = input.dataset.standardSize;
      this.applyDiecutMask();
      this.updatePatch();
      this.updateSummary();
      this.updateProgress();
    }

    selectPlacement(input) {
      this.qa('[data-placement]').forEach(option => { option.checked = option === input; });
      this.state.x = Number(input.dataset.x);
      this.state.y = Number(input.dataset.y);
      this.state.scale = Number(input.dataset.size);
      this.state.placement = input.value;
      this.state.patchTouched = true;
      this.setView('front');
      this.updatePatch();
      this.updateSummary();
      this.updateProgress();
    }

    updatePatch() {
      this.patchWrap.style.left = `${this.state.x}%`;
      this.patchWrap.style.top = `${this.state.y}%`;
      this.patchWrap.style.transform = `translate(-50%, -50%) scale(${this.state.scale / 100})`;
      this.patch.style.setProperty('--logo-size', `${this.state.logoSize}%`);
      this.patch.style.setProperty('--logo-x', `${this.state.logoX}%`);
      this.patch.style.setProperty('--logo-y', `${-this.state.logoY}%`);
      this.patch.style.setProperty('--logo-rotation', `${this.state.logoRotation}deg`);
      this.patchWrap.dataset.border = this.state.border === 'With border' ? 'yes' : 'no';
      this.patch.dataset.border = this.patchWrap.dataset.border;
      this.patchSize.value = this.state.scale;
      this.logoSize.value = this.state.logoSize;
      this.logoX.value = this.state.logoX;
      this.logoY.value = this.state.logoY;
      this.diecutSpacing.value = this.state.diecutSpacing;
      const sizeOutput = this.q('[data-size-output]');
      if (sizeOutput) sizeOutput.textContent = this.state.scale === 100 ? 'Center recommendation' : this.state.scale === 90 ? 'Offset recommendation' : `${this.state.scale}% of standard`;
      this.q('[data-size-value]').textContent = `${this.state.scale}%`;
      this.q('[data-logo-size-value]').textContent = `${this.state.logoSize}%`;
      this.q('[data-logo-x-value]').textContent = this.state.logoX === 0 ? 'Centered' : `${Math.abs(this.state.logoX)}% ${this.state.logoX < 0 ? 'left' : 'right'}`;
      this.q('[data-logo-y-value]').textContent = this.state.logoY === 0 ? 'Centered' : `${Math.abs(this.state.logoY)}% ${this.state.logoY > 0 ? 'up' : 'down'}`;
      this.q('[data-logo-rotation-value]').textContent = `${this.state.logoRotation}°`;
      const shape = this.checked('[data-shape]');
      const standard = shape?.dataset.standardSize || this.state.shapeSize;
      if (this.previewData) this.previewData.value = `${shape?.value || 'Rectangle'} (${standard}); ${this.state.placement}; X ${Math.round(this.state.x)}%; Y ${Math.round(this.state.y)}%; patch size ${this.state.scale}%; logo size ${this.state.logoSize}%; logo X ${this.state.logoX}%; logo Y ${this.state.logoY}%; rotation ${this.state.logoRotation}°; ${this.state.border}; fixed 4px border; die-cut spacing ${this.state.diecutSpacing}px`;
    }

    dragPatch(event) {
      if (!this.state.dragging || this.state.view !== 'front') return;
      const bounds = this.stage.getBoundingClientRect();
      this.state.x = Math.max(18, Math.min(82, ((event.clientX - bounds.left) / bounds.width) * 100));
      this.state.y = Math.max(18, Math.min(72, ((event.clientY - bounds.top) / bounds.height) * 100));
      this.state.placement = 'Custom adjusted';
      this.qa('[data-placement]').forEach(input => { input.checked = false; });
      this.updatePatch();
      this.updateSummary();
      this.state.patchTouched = true;
      this.updateProgress();
    }

    previewArtwork(file) {
      if (!file) {
        this.artImage.hidden = true;
        this.artImage.removeAttribute('src');
        this.state.artSource = '';
        this.state.diecutMask = '';
        this.diecutSource = null;
        this.previewText.hidden = false;
        this.artName.value = '';
        this.applyDiecutMask();
        this.updateProgress();
        return;
      }
      this.artName.value = file.name;
      const reader = new FileReader();
      reader.onload = event => {
        this.state.artSource = String(event.target.result);
        this.renderArtwork();
        this.updateProgress();
      };
      reader.readAsDataURL(file);
      this.updateProgress();
    }

    renderArtwork() {
      if (!this.state.artSource) return;
      const sourceImage = new Image();
      sourceImage.onload = () => {
        const width = Math.max(1, sourceImage.naturalWidth || 1000);
        const height = Math.max(1, sourceImage.naturalHeight || 1000);
        const ratio = Math.min(1, 1200 / Math.max(width, height));
        const canvas = document.createElement('canvas');
        canvas.width = Math.max(1, Math.round(width * ratio));
        canvas.height = Math.max(1, Math.round(height * ratio));
        const context = canvas.getContext('2d', { willReadFrequently: true });
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(sourceImage, 0, 0, canvas.width, canvas.height);
        const pixels = context.getImageData(0, 0, canvas.width, canvas.height);
        const ink = getComputedStyle(this.patch).color.match(/[\d.]+/g)?.slice(0, 3).map(Number) || [17, 17, 17];
        let minX = canvas.width;
        let minY = canvas.height;
        let maxX = -1;
        let maxY = -1;
        for (let index = 0; index < pixels.data.length; index += 4) {
          if (pixels.data[index + 3] === 0) continue;
          const pixel = index / 4;
          const x = pixel % canvas.width;
          const y = Math.floor(pixel / canvas.width);
          minX = Math.min(minX, x);
          minY = Math.min(minY, y);
          maxX = Math.max(maxX, x);
          maxY = Math.max(maxY, y);
          pixels.data[index] = ink[0];
          pixels.data[index + 1] = ink[1];
          pixels.data[index + 2] = ink[2];
        }
        context.putImageData(pixels, 0, 0);
        if (maxX >= minX && maxY >= minY) {
          const trimWidth = maxX - minX + 1;
          const trimHeight = maxY - minY + 1;
          const trimmed = document.createElement('canvas');
          trimmed.width = trimWidth;
          trimmed.height = trimHeight;
          trimmed.getContext('2d').drawImage(canvas, minX, minY, trimWidth, trimHeight, 0, 0, trimWidth, trimHeight);
          this.artImage.src = trimmed.toDataURL('image/png');
          this.diecutSource = trimmed;
          this.createDiecutMask(trimmed);
        } else {
          this.artImage.src = canvas.toDataURL('image/png');
          this.diecutSource = canvas;
          this.createDiecutMask(canvas);
        }
        this.artImage.hidden = false;
        this.previewText.hidden = true;
      };
      sourceImage.onerror = () => {
        this.artImage.src = this.state.artSource;
        this.artImage.hidden = false;
        this.previewText.hidden = true;
      };
      sourceImage.src = this.state.artSource;
    }

    createDiecutMask(source) {
      let silhouette = source;
      if (this.state.logoRotation) {
        const quarterTurn = this.state.logoRotation % 180 !== 0;
        const oriented = document.createElement('canvas');
        oriented.width = quarterTurn ? source.height : source.width;
        oriented.height = quarterTurn ? source.width : source.height;
        const orientedContext = oriented.getContext('2d');
        orientedContext.translate(oriented.width / 2, oriented.height / 2);
        orientedContext.rotate(this.state.logoRotation * Math.PI / 180);
        orientedContext.drawImage(source, -source.width / 2, -source.height / 2);
        silhouette = oriented;
      }
      const max = 420;
      const ratio = Math.min(1, max / Math.max(silhouette.width, silhouette.height));
      const width = Math.max(1, Math.round(silhouette.width * ratio));
      const height = Math.max(1, Math.round(silhouette.height * ratio));
      const cutMargin = Math.max(1, this.state.diecutSpacing);
      const padding = Math.ceil(cutMargin + 4);
      const mask = document.createElement('canvas');
      mask.width = width + padding * 2;
      mask.height = height + padding * 2;
      const context = mask.getContext('2d', { willReadFrequently: true });
      context.drawImage(silhouette, padding, padding, width, height);
      for (let angle = 0; angle < 360; angle += 8) {
        const radians = angle * Math.PI / 180;
        context.drawImage(silhouette, padding + Math.cos(radians) * cutMargin, padding + Math.sin(radians) * cutMargin, width, height);
      }
      const image = context.getImageData(0, 0, mask.width, mask.height);
      const exterior = new Uint8Array(mask.width * mask.height);
      const queue = [];
      const enqueue = (x, y) => {
        if (x < 0 || y < 0 || x >= mask.width || y >= mask.height) return;
        const point = y * mask.width + x;
        if (exterior[point] || image.data[point * 4 + 3] > 12) return;
        exterior[point] = 1;
        queue.push(point);
      };
      for (let x = 0; x < mask.width; x += 1) { enqueue(x, 0); enqueue(x, mask.height - 1); }
      for (let y = 0; y < mask.height; y += 1) { enqueue(0, y); enqueue(mask.width - 1, y); }
      for (let cursor = 0; cursor < queue.length; cursor += 1) {
        const point = queue[cursor];
        const x = point % mask.width;
        const y = Math.floor(point / mask.width);
        enqueue(x - 1, y);
        enqueue(x + 1, y);
        enqueue(x, y - 1);
        enqueue(x, y + 1);
      }
      for (let point = 0; point < exterior.length; point += 1) {
        const alpha = point * 4 + 3;
        image.data[alpha] = exterior[point] ? 0 : 255;
        image.data[alpha - 3] = 0;
        image.data[alpha - 2] = 0;
        image.data[alpha - 1] = 0;
      }
      context.putImageData(image, 0, 0);
      this.state.diecutMask = mask.toDataURL('image/png');
      this.state.diecutAspect = mask.width / mask.height;
      this.applyDiecutMask();
    }

    applyDiecutMask() {
      const active = this.patchWrap.dataset.shape === 'diecut' && this.state.diecutMask;
      const mask = active ? `url("${this.state.diecutMask}")` : '';
      this.patch.style.maskImage = mask;
      this.patch.style.webkitMaskImage = mask;
      this.patch.style.maskSize = active ? '100% 100%' : '';
      this.patch.style.webkitMaskSize = active ? '100% 100%' : '';
      this.patchWrap.style.aspectRatio = active ? String(this.state.diecutAspect) : '';
    }

    updateSummary() {
      const model = this.checked('[data-model]');
      const color = this.checked('[data-color]');
      const leather = this.checked('[data-leather]');
      const shape = this.checked('[data-shape]');
      this.q('[data-summary="hat"]').textContent = model ? `${model.value}${color ? ` · ${color.value}` : ''}` : 'Not selected';
      this.q('[data-summary="patch"]').textContent = leather ? leather.value : 'Not selected';
      this.q('[data-summary="shape"]').textContent = shape ? `${shape.value} · ${shape.dataset.standardSize}` : 'Rectangle · 3 × 2 in';
      this.q('[data-summary="placement"]').textContent = this.state.placement;
    }

    updateProgress() {
      const complete = {
        hat: Boolean(this.state.model && this.state.colorName),
        design: Boolean(this.state.artSource || this.q('[data-custom-text]').value.trim()),
        patch: Boolean(this.state.patchTouched),
        details: Boolean(this.q('[data-approval]').checked)
      };
      const order = ['hat', 'design', 'patch', 'details'];
      let activeIndex = order.findIndex(key => !complete[key]);
      if (activeIndex < 0) activeIndex = order.length - 1;
      this.qa('[data-progress]').forEach(item => {
        const key = item.dataset.progress;
        const index = order.indexOf(key);
        item.classList.remove('is-complete', 'is-active', 'is-locked');
        if (index < activeIndex || (index === activeIndex && complete[key])) item.classList.add('is-complete');
        else if (index === activeIndex) item.classList.add('is-active');
        else item.classList.add('is-locked');
      });
    }

    async handleSubmit(event) {
      if (this.exportSubmissionReady) return;
      this.validate(event);
      if (event.defaultPrevented) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const submitter = event.submitter;
      this.setExportStatus('Preparing your approved preview and production artwork…', 'working');
      if (submitter) submitter.setAttribute('aria-busy', 'true');
      try {
        const [previewCanvas, patchCanvas] = await Promise.all([
          this.createApprovedPreviewCanvas(),
          this.createProductionPatchCanvas()
        ]);
        const [previewBlob, patchBlob] = await Promise.all([
          this.canvasToBlob(previewCanvas),
          this.canvasToBlob(patchCanvas)
        ]);
        const stamp = new Date().toISOString().replace(/[:.]/g, '-');
        this.attachGeneratedFile(this.approvedPreviewInput, previewBlob, `approved-hat-preview-${stamp}.png`);
        this.attachGeneratedFile(this.productionArtInput, patchBlob, `production-patch-${stamp}.png`);
        this.setExportStatus('Preview and production artwork attached. Adding your hat to the cart…', 'success');
        this.exportSubmissionReady = true;
        this.form.requestSubmit(submitter || undefined);
        setTimeout(() => { this.exportSubmissionReady = false; }, 1000);
      } catch (error) {
        console.error('DCE export failed', error);
        this.setExportStatus('We could not prepare the order files. Please try Add to Cart again.', 'error');
      } finally {
        if (submitter) submitter.removeAttribute('aria-busy');
      }
    }

    setExportStatus(message, state) {
      if (!this.exportStatus) return;
      this.exportStatus.hidden = false;
      this.exportStatus.textContent = message;
      this.exportStatus.dataset.state = state;
    }

    attachGeneratedFile(input, blob, filename) {
      if (!input || typeof DataTransfer === 'undefined') throw new Error('Generated file attachments are not supported in this browser.');
      const transfer = new DataTransfer();
      transfer.items.add(new File([blob], filename, { type: 'image/png', lastModified: Date.now() }));
      input.files = transfer.files;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      if (!input.files || input.files.length !== 1) throw new Error('Generated file could not be attached to the order form.');
    }

    canvasToBlob(canvas) {
      return new Promise((resolve, reject) => canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('PNG export failed.')), 'image/png'));
    }

    async loadExportImage(source) {
      if (!source) throw new Error('Missing image source.');
      try {
        const response = await fetch(source, { mode: 'cors', credentials: 'omit' });
        if (!response.ok) throw new Error(`Image request failed: ${response.status}`);
        const blob = await response.blob();
        if ('createImageBitmap' in window) return await createImageBitmap(blob);
        source = URL.createObjectURL(blob);
      } catch (error) {
        if (source.startsWith('data:') || source.startsWith('blob:')) {
          // These sources can still be loaded directly below.
        } else {
          console.warn('Falling back to direct image export loading.', error);
        }
      }
      return await new Promise((resolve, reject) => {
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.onload = () => resolve(image);
        image.onerror = () => reject(new Error(`Could not load export image: ${source}`));
        image.src = source;
      });
    }

    imageDimensions(image) {
      return { width: image.naturalWidth || image.width, height: image.naturalHeight || image.height };
    }

    drawImageContain(context, image, x, y, width, height) {
      const size = this.imageDimensions(image);
      const ratio = Math.min(width / size.width, height / size.height);
      const drawWidth = size.width * ratio;
      const drawHeight = size.height * ratio;
      context.drawImage(image, x + (width - drawWidth) / 2, y + (height - drawHeight) / 2, drawWidth, drawHeight);
    }

    drawImageCover(context, image, x, y, width, height) {
      const size = this.imageDimensions(image);
      const ratio = Math.max(width / size.width, height / size.height);
      const drawWidth = size.width * ratio;
      const drawHeight = size.height * ratio;
      context.drawImage(image, x + (width - drawWidth) / 2, y + (height - drawHeight) / 2, drawWidth, drawHeight);
    }

    patchAspect(shape) {
      if (shape === 'circle' || shape === 'hex') return 1;
      if (shape === 'diecut') return this.state.diecutAspect || 1;
      return 1.5;
    }

    patchWidthRatio(shape) {
      if (shape === 'circle' || shape === 'hex') return 0.22;
      if (shape === 'diecut') return 0.25;
      return 0.27;
    }

    makeShapePath(context, shape, width, height, inset = 0) {
      const x = inset;
      const y = inset;
      const w = Math.max(1, width - inset * 2);
      const h = Math.max(1, height - inset * 2);
      context.beginPath();
      if (shape === 'circle' || shape === 'oval') {
        context.ellipse(x + w / 2, y + h / 2, w / 2, h / 2, 0, 0, Math.PI * 2);
      } else if (shape === 'hex') {
        [[.5,0],[.93,.25],[.93,.75],[.5,1],[.07,.75],[.07,.25]].forEach(([px, py], index) => index ? context.lineTo(x + px * w, y + py * h) : context.moveTo(x + px * w, y + py * h));
        context.closePath();
      } else if (shape === 'longhex') {
        [[.5,0],[1,.24],[1,.76],[.5,1],[0,.76],[0,.24]].forEach(([px, py], index) => index ? context.lineTo(x + px * w, y + py * h) : context.moveTo(x + px * w, y + py * h));
        context.closePath();
      } else if (shape === 'stadium') {
        context.moveTo(x + .1 * w, y + .95 * h);
        context.quadraticCurveTo(x + .06 * w, y + .94 * h, x + .05 * w, y + .865 * h);
        context.lineTo(x + .013 * w, y + .35 * h);
        context.quadraticCurveTo(x, y + .2 * h, x + .1 * w, y + .125 * h);
        context.quadraticCurveTo(x + .5 * w, y - .04 * h, x + .9 * w, y + .125 * h);
        context.quadraticCurveTo(x + w, y + .2 * h, x + .987 * w, y + .35 * h);
        context.lineTo(x + .95 * w, y + .865 * h);
        context.quadraticCurveTo(x + .94 * w, y + .94 * h, x + .9 * w, y + .95 * h);
        context.closePath();
      } else {
        const radius = Math.min(w, h) * .08;
        context.roundRect(x, y, w, h, radius);
      }
      return context;
    }

    async createProductionPatchCanvas(width = 1400) {
      const shape = this.patchWrap.dataset.shape || 'rectangle';
      const aspect = this.patchAspect(shape);
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = Math.max(1, Math.round(width / aspect));
      const context = canvas.getContext('2d');
      const content = document.createElement('canvas');
      content.width = canvas.width;
      content.height = canvas.height;
      const contentContext = content.getContext('2d');
      const leather = this.checked('[data-leather]');
      const texture = leather?.dataset.texture ? await this.loadExportImage(leather.dataset.texture) : null;
      const mask = document.createElement('canvas');
      mask.width = canvas.width;
      mask.height = canvas.height;
      const maskContext = mask.getContext('2d');
      if (shape === 'diecut' && this.state.diecutMask) {
        const maskImage = await this.loadExportImage(this.state.diecutMask);
        this.drawImageContain(maskContext, maskImage, 0, 0, mask.width, mask.height);
      } else {
        this.makeShapePath(maskContext, shape, mask.width, mask.height);
        maskContext.fillStyle = '#fff';
        maskContext.fill();
      }
      contentContext.save();
      if (texture) this.drawImageCover(contentContext, texture, 0, 0, content.width, content.height);
      else {
        contentContext.fillStyle = leather?.dataset.bg || '#b56f48';
        contentContext.fillRect(0, 0, content.width, content.height);
      }
      const ink = leather?.dataset.ink || '#111111';
      await this.drawProductionDesign(contentContext, content.width, content.height, ink);
      contentContext.globalCompositeOperation = 'destination-in';
      contentContext.drawImage(mask, 0, 0);
      contentContext.restore();
      if (this.state.border === 'With border') {
        const borderWidth = Math.max(4, Math.round((4 / Math.max(1, this.patchWrap.getBoundingClientRect().width)) * canvas.width));
        if (shape === 'diecut') {
          const outline = document.createElement('canvas');
          outline.width = canvas.width;
          outline.height = canvas.height;
          const outlineContext = outline.getContext('2d');
          outlineContext.fillStyle = ink;
          for (let angle = 0; angle < 360; angle += 6) {
            const radians = angle * Math.PI / 180;
            outlineContext.drawImage(mask, Math.cos(radians) * borderWidth, Math.sin(radians) * borderWidth);
          }
          outlineContext.globalCompositeOperation = 'source-in';
          outlineContext.fillRect(0, 0, outline.width, outline.height);
          context.drawImage(outline, 0, 0);
        }
      }
      context.drawImage(content, 0, 0);
      if (this.state.border === 'With border' && shape !== 'diecut') {
        const borderWidth = Math.max(4, Math.round((4 / Math.max(1, this.patchWrap.getBoundingClientRect().width)) * canvas.width));
        context.save();
        this.makeShapePath(context, shape, canvas.width, canvas.height, borderWidth / 2);
        context.strokeStyle = ink;
        context.lineWidth = borderWidth;
        context.stroke();
        context.restore();
      }
      return canvas;
    }

    async drawProductionDesign(context, width, height, ink) {
      if (this.state.artSource && this.artImage.src) {
        const artwork = await this.loadExportImage(this.artImage.src);
        const boxWidth = width * this.state.logoSize / 100;
        const boxHeight = height * this.state.logoSize / 100;
        const x = (width - boxWidth) / 2 + boxWidth * this.state.logoX / 100;
        const y = (height - boxHeight) / 2 - boxHeight * this.state.logoY / 100;
        context.save();
        context.translate(x + boxWidth / 2, y + boxHeight / 2);
        context.rotate(this.state.logoRotation * Math.PI / 180);
        this.drawImageContain(context, artwork, -boxWidth / 2, -boxHeight / 2, boxWidth, boxHeight);
        context.restore();
      } else {
        const text = this.q('[data-custom-text]').value.trim() || 'YOUR LOGO';
        context.save();
        context.fillStyle = ink;
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.font = `900 ${Math.round(Math.min(width, height) * .12)}px Arial, sans-serif`;
        context.fillText(text, width / 2, height / 2, width * .82);
        context.restore();
      }
    }

    async createApprovedPreviewCanvas(width = 1600) {
      const stageRect = this.stage.getBoundingClientRect();
      const aspect = stageRect.width / Math.max(1, stageRect.height);
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = Math.max(1, Math.round(width / aspect));
      const context = canvas.getContext('2d');
      context.fillStyle = '#ffffff';
      context.fillRect(0, 0, canvas.width, canvas.height);
      const hat = await this.loadExportImage(this.state.front || this.hatImage.src);
      this.drawImageContain(context, hat, 0, 0, canvas.width, canvas.height);
      const patch = await this.createProductionPatchCanvas(1400);
      const shape = this.patchWrap.dataset.shape || 'rectangle';
      const patchWidth = canvas.width * this.patchWidthRatio(shape) * this.state.scale / 100;
      const patchHeight = patchWidth / this.patchAspect(shape);
      const patchX = canvas.width * this.state.x / 100 - patchWidth / 2;
      const patchY = canvas.height * this.state.y / 100 - patchHeight / 2;
      context.save();
      context.shadowColor = 'rgba(0,0,0,.45)';
      context.shadowBlur = Math.max(8, canvas.width * .008);
      context.shadowOffsetY = Math.max(5, canvas.width * .005);
      context.drawImage(patch, patchX, patchY, patchWidth, patchHeight);
      context.restore();
      return canvas;
    }

    validate(event) {
      this.qa('.dce-creator__invalid').forEach(element => element.classList.remove('dce-creator__invalid'));
      const requirements = [
        ['[data-model]:checked', '[data-step="hat"]'],
        ['[data-color]:checked', '[data-colors]'],
        ['[data-leather]:checked', '[data-step="patch"]'],
        ['[data-shape]:checked', '[data-step="patch"]'],
        ['[data-approval]:checked', '[data-step="details"]']
      ];
      const missing = requirements.find(([selector]) => !this.querySelector(selector));
      const designMissing = !this.q('[data-art]').files?.length && !this.q('[data-custom-text]').value.trim();
      const fittedMissing = ['flexfit-6533', 'flexfit-6597'].includes(this.state.model) && !this.checked('[data-size]');
      if (!missing && !fittedMissing && !designMissing) return;
      event.preventDefault();
      const target = fittedMissing ? this.q('[data-sizes]') : designMissing ? this.q('[data-step="design"]') : this.q(missing[1]);
      target.classList.add('dce-creator__invalid');
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    reset() {
      this.qa('input[type="radio"], input[type="checkbox"]').forEach(input => { input.checked = false; });
      this.qa('input[type="text"], input[type="search"], input[type="file"], textarea').forEach(input => { input.value = ''; });
      this.checked('[data-shape]');
      const defaultShape = this.q('[data-shape][value="Rectangle"]');
      const defaultPlacement = this.q('[data-placement][value="Center front"]');
      const defaultLeather = this.q('[data-leather]');
      const defaultBorder = this.q('[data-border][value="With border"]');
      defaultShape.checked = true;
      defaultPlacement.checked = true;
      defaultLeather.checked = true;
      defaultBorder.checked = true;
      this.state = { model: '', modelName: '', colorName: '', front: '', side: '', view: 'front', x: 50, y: 43, scale: 100, logoSize: 75, logoX: 0, logoY: 0, logoRotation: 0, diecutSpacing: 8, border: 'With border', shapeSize: '3 × 2 in', placement: 'Center front', artSource: '', diecutMask: '', diecutAspect: 1, patchTouched: false, dragging: false };
      this.q('[data-sizes]').hidden = true;
      this.q('[data-view-switch]').hidden = true;
      this.qa('[data-color-card]').forEach(card => { card.hidden = true; });
      this.q('[data-color-help]').textContent = 'Choose a hat series to view available colors.';
      this.artImage.hidden = true;
      this.artImage.removeAttribute('src');
      this.previewText.hidden = false;
      this.previewText.textContent = 'YOUR LOGO';
      this.patchWrap.hidden = false;
      this.patchWrap.removeAttribute('style');
      this.patchWrap.dataset.shape = 'rectangle';
      this.patchWrap.dataset.border = 'yes';
      this.diecutSource = null;
      this.q('[data-diecut-spacing-control]').hidden = true;
      this.diecutSpacing.value = this.state.diecutSpacing;
      this.q('[data-diecut-spacing-value]').textContent = `${this.state.diecutSpacing} px`;
      this.patch.removeAttribute('style');
      this.patch.dataset.shape = 'rectangle';
      this.patch.dataset.pattern = 'grain';
      this.hatImage.src = this.dataset.defaultHat || this.hatImage.src;
      this.selectLeather(defaultLeather);
      this.updatePatch();
      this.updateSummary();
      this.updateProgress();
    }
  });
}
